export function routerHead(title: string) {
  return () => ({
    meta: [
      {
        title: `${title} - Productadministratie`,
      },
    ],
  });
}
